import { List, Create, Edit, View, MyPreSanction, Copy } from "../Components/index.js";

export default [
    {
        path: "/voucher/bq-store/my-pre-sanction",
        component: MyPreSanction,
        name: "bq-store.voucher.my.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/pre-sanction",
        component: List,
        name: "bq-store.voucher.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/pre-sanction/create",
        component: Create,
        name: "bq-store.voucher.pre-sanction.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/pre-sanction/:id/edit",
        component: Edit,
        name: "bq-store.voucher.pre-sanction.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/pre-sanction/:id/view",
        component: View,
        name: "bq-store.voucher.pre-sanction.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/pre-sanction/:id/copy",
        component: Copy,
        name: "bq-store.voucher.pre-sanction.copy",
        meta: {
            requiresAuth: true,
        },
    },
];
